var Header_megamenu_2_block_slider = document.querySelector('.Header_megamenu_2_block_slider');

if (Header_megamenu_2_block_slider) {
    new Swiper('.Header_megamenu_2_block_slider', {
        loop: false,
        grabCursor: false,
        spaceBetween: 16,
        slidesPerGroup: 1,
        slidesPerView: 2,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            750: {
                slidesPerView: 2,
                spaceBetween: 16
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
}


var Header_megamenu_common_block_slider = document.querySelector('.Header_megamenu_common_block_slider');

if (Header_megamenu_common_block_slider) {
    new Swiper('.Header_megamenu_common_block_slider', {
        loop: false,
        grabCursor: false,
        spaceBetween: 16,
        slidesPerGroup: 1,
        slidesPerView: 4,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            750: {
                slidesPerView: 2,
                spaceBetween: 16
            },
            990: {
                slidesPerView: 4,
                spaceBetween: 16
            },
            1200: {
                
            },
            1440: {
            }
        }
    })
}